// extracted by mini-css-extract-plugin
module.exports = {"menuContainer":"menu_menuContainer__2HTnF","formContainer":"menu_formContainer__3zyyl","checkboxContainer":"menu_checkboxContainer__37CD7"};